/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Copy_LabelInputs */

const en_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy selected events`)
};

const fr_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier les evenements selectionnes`)
};

const de_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse kopieren`)
};

const it_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia gli eventi selezionati`)
};

const ru_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать выбранные события`)
};

const es_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar eventos seleccionados`)
};

const zh_cn2_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制所选事件`)
};

const ja_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントをコピー`)
};

const hi_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं की प्रतिलिपि बनाएँ`)
};

const pt_pt2_context_menu_copy_label = /** @type {(inputs: Context_Menu_Copy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Copy selected events" |
*
* @param {Context_Menu_Copy_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_copy_label = /** @type {((inputs?: Context_Menu_Copy_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Copy_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_copy_label(inputs)
	if (locale === "de") return de_context_menu_copy_label(inputs)
	if (locale === "it") return it_context_menu_copy_label(inputs)
	if (locale === "ru") return ru_context_menu_copy_label(inputs)
	if (locale === "es") return es_context_menu_copy_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_copy_label(inputs)
	if (locale === "ja") return ja_context_menu_copy_label(inputs)
	if (locale === "hi") return hi_context_menu_copy_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_copy_label(inputs)
	return en_context_menu_copy_label(inputs)
});